import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import Hero from "./components/Hero";
import UpcomingEvents from "./components/UpcomingEvents";
import PastEvents from "./components/PastEvents";
import Topics from "./components/Topics";
import Schedule from "./components/Schedule";
import Guidelines from "./components/Guidelines";
import CTA from "./components/CTA";

const StudyGroupsPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full">
				<Hero />
				<UpcomingEvents />
				<PastEvents />
				<Topics />
				<Schedule />
				<Guidelines />
				<CTA />
			</div>
		</Layout>
	);
};

export default StudyGroupsPage;
